<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add Question">
      <div class="row">
        <div class="col-md-6 form-group">
          Parent Topic
          <b-form-select v-model="parentTopic" @change="getTopics()" required>
            <option
              v-for="(parentTopic, index) in parentTopics"
              :key="index"
              :value="parentTopic.id"
            >
              {{ parentTopic.name }}
            </option>
          </b-form-select>
          <div v-if="parentTopicEmpty" style="color: red">
            Parent topic is required
          </div>
        </div>

        <div class="col-md-6 form-group" v-if="parentTopic != ''">
          Topic
          <b-form-select v-model="topic" @change="getSubtopics()" required>
            <option
              v-for="(topic, index) in topics"
              :key="index"
              :value="topic.id"
            >
              {{ topic.name }}
            </option>
          </b-form-select>
          <div v-if="topicEmpty" style="color: red">Topic is required</div>
        </div>

        <div class="col-md-6 form-group" v-if="topic != ''">
          Sub Topic
          <b-form-select
            v-model="subtopic"
            @change="subtopicEmpty = false"
            required
          >
            <option
              v-for="(subtopic, index) in subtopics"
              :key="index"
              :value="subtopic.id"
            >
              {{ subtopic.name }}
            </option>
          </b-form-select>
          <div v-if="subtopicEmpty" style="color: red">
            Subtopic is required
          </div>
        </div>

        <div class="col-md-6 form-group" v-if="subtopic != ''">
          Question Type
          <b-form-select
            class="form-control"
            v-model="questionType"
            @change="questionTypeEmpty = false"
            required
          >
            <option
              v-for="(questionTypeOption, index) in questionTypeOptions"
              :key="index"
              :value="questionTypeOption.value"
            >
              {{ questionTypeOption.text }}
            </option>
          </b-form-select>
          <div v-if="questionTypeEmpty" style="color: red">
            Question type is required
          </div>
        </div>
        <div class="col-md-12" v-if="questionType != ''">
          Question
          <vue-editor
            :config="config"
            v-model="question"
            @focus="questionEmpty = false"
            required
          />
          <!-- <ckeditor
            :config="config"
            v-model="question"
            @focus="questionEmpty = false"
            required
          >
          </ckeditor> -->
          <div v-if="questionEmpty" style="color: red">
            Question is required
          </div>
          <br />
        </div>

        <div class="col-md-6 form-group" v-if="questionType == 'objective'">
          Options 1
          <input
            class="form-control"
            placeholder="Enter an option"
            v-model="option1"
            @focus="option1Empty = false"
            required
          />
          <div v-if="option1Empty" style="color: red">Option 1 is required</div>
        </div>
        <div class="col-md-6 form-group" v-if="questionType == 'objective'">
          Options 2
          <input
            class="form-control"
            placeholder="Enter an option"
            v-model="option2"
            @focus="option2Empty = false"
            required
          />
          <div v-if="option2Empty" style="color: red">Option 2 is required</div>
        </div>
        <div class="col-md-6 form-group" v-if="questionType == 'objective'">
          Options 3
          <input
            class="form-control"
            placeholder="Enter an option"
            v-model="option3"
          />
        </div>
        <div class="col-md-6 form-group" v-if="questionType == 'objective'">
          Options 4
          <input
            class="form-control"
            placeholder="Enter an option"
            v-model="option4"
          />
        </div>
        <div class="col-md-6 form-group" v-if="questionType == 'objective'">
          Options 5
          <input
            class="form-control"
            placeholder="Enter an option"
            v-model="option5"
          />
        </div>
        <div class="w-100" v-if="questionType == 'objective'"></div>
        <div class="col-md-6 form-group" v-if="questionType != ''">
          Question Image
          <b-form-file
            type="file"
            class="form-control"
            @change="questionImage = $event.target.files[0]"
          ></b-form-file>
        </div>
        <div
          class="col-md-6 form-group"
          v-if="questionType != '' && questionType != 'objective'"
        >
          Correct Answer
          <input
            class="form-control"
            v-model="correctAnswer"
            @focus="correctAnswerEmpty = false"
            required
          />
          <div v-if="correctAnswerEmpty" style="color: red">
            Correct answer is required
          </div>
        </div>
        <div
          class="col-md-6 form-group"
          v-if="questionType != '' && questionType == 'coding'"
        >
          Minimum Lines
          <input class="form-control" v-model="minimum_lines" required />
        </div>

        <div
          class="col-md-6 form-group"
          v-if="questionType != '' && questionType == 'objective'"
        >
          Correct Option
          <b-form-select
            class="form-control"
            v-model="correctAnswer"
            @change="correctAnswerEmpty = false"
            required
          >
            <option v-if="option1 != ''" :value="option1">1</option>
            <option v-if="option2 != ''" :value="option2">2</option>
            <option v-if="option3 != ''" :value="option3">3</option>
            <option v-if="option4 != ''" :value="option4">4</option>
            <option v-if="option5 != ''" :value="option5">5</option>
          </b-form-select>
          <div v-if="correctAnswerEmpty" style="color: red">
            Correct option is required
          </div>
        </div>

        <div
          class="row m-0"
          style="width: 100%"
          v-for="(soln, index) in moreSolution"
          :key="index"
        >
          <div class="col-md-6 form-group" v-if="correctAnswer != ''">
            Solution Type
            <b-form-select
              class="form-control"
              v-model="moreSolution[index].solutionType"
              @change="solutionTypeEmpty = false"
              required
            >
              <option value="video">Video</option>
              <option value="description">Description</option>
            </b-form-select>
            <div
              v-if="solutionTypeEmpty && moreSolution[index].solutionType == ''"
              style="color: red"
            >
              Solution type is required
            </div>
          </div>

          <div
            class="col-md-5 form-group"
            v-if="
              moreSolution[index].solutionType == 'description' &&
                correctAnswer != ''
            "
          >
            Solution Image
            <b-form-file
              type="file"
              class="form-control"
              @change="
                moreSolution[index].solutionImage = $event.target.files[0]
              "
            />
          </div>

          <div
            class="col-md-5 form-group"
            v-if="
              moreSolution[index].solutionType == 'video' && correctAnswer != ''
            "
          >
            Video Name
            <input
              class="form-control"
              v-model="moreSolution[index].videoName"
              @focus="solutionNameEmpty = false"
              required
            />
            <div
              v-if="solutionNameEmpty && moreSolution[index].videoName == ''"
              style="color: red"
            >
              Video name is required
            </div>
          </div>

          <div
            class="col-md-1 form-group"
            v-if="moreSolution[index].solutionType != '' && correctAnswer != ''"
          >
            <b-button
              variant="danger"
              class="mt-4"
              @click="removeSolution(index)"
              ><i class="fas fa-trash"></i
            ></b-button>
          </div>

          <div
            class="col-md-12 form-group"
            v-if="
              moreSolution[index].solutionType == 'video' &&
                moreSolution[index].solutionType != '' &&
                correctAnswer != ''
            "
          >
            Solution URL
            <input
              class="form-control"
              placeholder="Enter Youtube URL"
              v-model="moreSolution[index].solutionURL"
              @focus="
                (solutionURLEmpty = false), (solutionURLFormatInvalid = false)
              "
              required
            />
            <div
              v-if="solutionURLEmpty && moreSolution[index].solutionURL == ''"
              style="color: red"
            >
              Solution URL is required
            </div>
            <div
              v-if="
                solutionURLFormatInvalid &&
                  !moreSolution[index].solutionURL.match(
                    /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
                  )
              "
              style="color: red"
            >
              Youtube URL format is invalid
            </div>
          </div>

          <div
            class="col-md-12 form-group"
            v-if="
              moreSolution[index].solutionType == 'description' &&
                moreSolution[index].solutionType != '' &&
                correctAnswer != ''
            "
          >
            Solution
            <vue-editor
              :config="config"
              v-model="moreSolution[index].solutionDescription"
              @focus="solutionDescriptionEmpty = false"
            />
            <!-- <ckeditor
              :config="config"
              v-model="moreSolution[index].solutionDescription"
              @focus="solutionDescriptionEmpty = false"
            ></ckeditor> -->
            <div
              v-if="
                solutionDescriptionEmpty &&
                  moreSolution[index].solutionDescription == ''
              "
              style="color: red"
            >
              Solution description is required
            </div>
          </div>
        </div>
        <div class="text-right col-md-12 form-group" v-if="correctAnswer != ''">
          <b-button variant="success" @click="appendMoreSolution()"
            >Add Solution</b-button
          >
        </div>
      </div>
      <div class="text-center form-group" v-if="saveEnable()">
        <b-button variant="success" type="submit" @click="addQuestion()"
          >Save</b-button
        >
      </div>
      <!-- Loader -->
      <b-overlay
        :show="loader"
        no-wrap
        blur="2px"
        opacity="0.60"
        class="position-fixed"
      >
        <template #overlay>
          <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
        </template>
      </b-overlay>
    </base-block>
    <br />
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      config: {
        toolbar: [
          {
            name: "clipboard",
            groups: ["clipboard", "undo"],
            items: [
              "Cut",
              "Copy",
              "Paste",
              "PasteText",
              "PasteFromWord",
              "-",
              "Undo",
              "Redo",
            ],
          },
          {
            name: "editing",
            groups: ["find", "selection", "spellchecker"],
            items: ["Find", "Replace", "-", "SelectAll", "-", "Scayt"],
          },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },
          {
            name: "insert",
            items: [
              "Image",
              "Flash",
              "Table",
              "HorizontalRule",
              "Smiley",
              "SpecialChar",
              "PageBreak",
              "Iframe",
            ],
          },
          { name: "tools", items: ["Maximize", "ShowBlocks"] },
          {
            name: "document",
            groups: ["mode", "document", "doctools"],
            items: ["Source"],
          },
          {
            name: "basicstyles",
            groups: ["basicstyles", "cleanup"],
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              "Subscript",
              "Superscript",
              "-",
              "CopyFormatting",
              "RemoveFormat",
            ],
          },
          "/",
          {
            name: "paragraph",
            groups: ["list", "indent", "blocks", "align", "bidi"],
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "Blockquote",
              "CreateDiv",
              "-",
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock",
              "-",
              "BidiLtr",
              "BidiRtl",
              "Language",
            ],
          },

          { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "others", items: ["-"] },
          { name: "about", items: ["About"] },
          { name: "mathjax", items: ["Mathjax"] },
        ],
        extraPlugins: ["mathjax", "font", "justify"],
        mathJaxLib:
          "//cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-AMS_HTML",
      },
      loader: false,
      solutionURLFormatInvalid: false,
      solutionDescriptionEmpty: false,
      solutionNameEmpty: false,
      solutionURLEmpty: false,
      solutionTypeEmpty: false,
      option2Empty: false,
      option1Empty: false,
      correctAnswerEmpty: false,
      questionEmpty: false,
      questionTypeEmpty: false,
      subtopicEmpty: false,
      topicEmpty: false,
      parentTopicEmpty: false,
      option1: "",
      option2: "",
      option3: "",
      option4: "",
      option5: "",
      requiredSolutionIndex: "",
      questionTypeOptions: [
        {
          text: "Fillups",
          value: "fill_in_blank",
        },
        {
          text: "MCQ",
          value: "objective",
        },
        {
          text: "Coding",
          value: "coding",
        },
      ],
      subtopic: "",
      subtopics: [],
      parentTopic: "",
      topic: "",
      topics: [],
      parentTopics: [],
      question: "",
      minimum_lines: "",
      questionType: "",
      questionImage: [],
      correctAnswer: "",
      moreSolution: [],
    };
  },
  mounted() {
    this.getParentTopics();
  },
  methods: {
    removeSolution(index) {
      this.moreSolution.splice(index, 1);
    },
    async addQuestion() {
      this.loader = true;
      if (this.parentTopic == "") {
        this.parentTopicEmpty = true;
        return;
      }

      if (this.topic == "") {
        this.topicEmpty = true;
        return;
      }

      if (this.subtopic == "") {
        this.subtopicEmpty = true;
        return;
      }

      if (this.questionType == "") {
        this.questionTypeEmpty = true;
        return;
      }

      if (this.question == "") {
        this.questionEmpty = true;
        return;
      }

      if (this.correctAnswer == "") {
        this.correctAnswerEmpty = true;
        return;
      }

      if (this.questionType == "objective") {
        if (this.option1 == "") {
          this.option1Empty = true;
          return;
        }

        if (this.option2 == "") {
          this.option2Empty = true;
          return;
        }
      }
      if (this.moreSolution.length > 0) {
        let regex = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
        for (var x = 0; x < this.moreSolution.length; x++) {
          if (this.moreSolution[x].solutionType == "") {
            this.solutionTypeEmpty = true;
            return;
          }

          if (this.moreSolution[x].solutionType == "video") {
            if (this.moreSolution[x].solutionURL == "") {
              this.solutionURLEmpty = true;
              return;
            }

            if (!this.moreSolution[x].solutionURL.match(regex)) {
              this.solutionURLFormatInvalid = true;
              return;
            }

            if (this.moreSolution[x].videoName == "") {
              this.solutionNameEmpty = true;
              return;
            }
          } else {
            if (this.moreSolution[x].solutionDescription == "") {
              this.solutionDescriptionEmpty = true;
              return;
            }
          }
        }
      }
      this.loader = true;
      let solutions = [];
      for (var i = 0; i < this.moreSolution.length; i++) {
        if (this.moreSolution[i].solutionType == "video") {
          solutions.push({
            type: this.moreSolution[i].solutionType,
            video_url: this.moreSolution[i].solutionURL,
            video_name: this.moreSolution[i].videoName,
          });
        } else {
          solutions.push({
            type: this.moreSolution[i].solutionType,
            description: this.moreSolution[i].solutionDescription,
            image: this.moreSolution[i].solutionImage,
          });
        }
      }
      let topicIds = [this.parentTopic, this.topic, this.subtopic];
      const formdata = new FormData();
      formdata.append("topic_id", this.subtopic);
      formdata.append("question", this.question);
      formdata.append("minimum_lines", this.minimum_lines);
      formdata.append("question_type", this.questionType);
      formdata.append("image", this.questionImage);
      formdata.append("answer", this.correctAnswer);
      formdata.append("topic_ids", topicIds);
      for (var j = 0; j < solutions.length; j++) {
        if (solutions[j].type == "video") {
          formdata.append("solutions[" + j + "][type]", solutions[j].type);
          formdata.append(
            "solutions[" + j + "][video_url]",
            solutions[j].video_url
          );
          formdata.append(
            "solutions[" + j + "][video_name]",
            solutions[j].video_name
          );
        } else {
          formdata.append("solutions[" + j + "][type]", solutions[j].type);
          formdata.append(
            "solutions[" + j + "][description]",
            solutions[j].description
          );
          formdata.append("solutions[" + j + "][image]", solutions[j].image);
        }
      }
      if (this.questionType == "objective") {
        formdata.append("options[" + 0 + "]", this.option1);
        formdata.append("options[" + 1 + "]", this.option2);
        formdata.append("options[" + 2 + "]", this.option3);
        formdata.append("options[" + 3 + "]", this.option4);
        formdata.append("options[" + 4 + "]", this.option5);
      }
      await axios
        .post(`${this.$store.getters.baseUrl}/question/store`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.loader = false;
            this.$swal("Success", "Question added successfully", "success");
            this.$router.push({ name: "Tables Questions" });
            (this.parentTopic = ""), (this.topic = "");
            this.subtopic = "";
            this.questionType = "";
            this.question = "";
            this.questionImage = "";
            this.correctAnswer = "";
            this.option1 = "";
            this.option2 = "";
            this.option3 = "";
            this.option4 = "";
            this.option5 = "";
            this.moreSolution = [];
            solutions = [];
          } else {
            this.loader = false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getSubtopics() {
      this.topicEmpty = false;
      this.subtopic = "";
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.topic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.subtopics = response.data.topics;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async getTopics() {
      this.parentTopicEmpty = false;
      this.topic = "";
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.parentTopic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.topics = response.data.topics;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async getParentTopics() {
      await axios
        .get(`${this.$store.getters.baseUrl}/topics`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.parentTopics = response.data.topics;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    appendMoreSolution() {
      this.moreSolution.push({
        solutionType: "",
        solutionURL: "",
        solutionDescription: "",
        videoName: "",
        solutionImage: [],
      });
    },
    saveEnable() {
      if (this.correctAnswer != "") {
        return true;
      } else return false;
    },
  },
};
</script>
